import { notification } from 'antd';
import { baseURL } from '../../config';
import { saveAs } from 'file-saver';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  InfoCircleOutlined, 
  WarningOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

// Enhanced color palette matching your UI
const colors = {
  primary: '#00796b',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#1677ff',
  neutral: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E8E8E8',
    300: '#D9D9D9',
    400: '#BFBFBF',
    500: '#8C8C8C',
    600: '#595959',
    700: '#434343',
    800: '#262626',
    900: '#1F1F1F'
  }
};

// Enhanced status configuration
const statusConfig = {
  'success': {
    color: colors.success,
    backgroundColor: '#f6ffed',
    borderColor: '#b7eb8f',
    icon: <CheckCircleOutlined style={{ color: colors.success, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)'
  },
  'Success': {
    color: colors.success,
    backgroundColor: '#f6ffed',
    borderColor: '#b7eb8f',
    icon: <CheckCircleOutlined style={{ color: colors.success, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)'
  },
  'error': {
    color: colors.error,
    backgroundColor: '#fff2f0',
    borderColor: '#ffccc7',
    icon: <CloseCircleOutlined style={{ color: colors.error, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)'
  },
  'Error': {
    color: colors.error,
    backgroundColor: '#fff2f0',
    borderColor: '#ffccc7',
    icon: <CloseCircleOutlined style={{ color: colors.error, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)'
  },
  'warning': {
    color: colors.warning,
    backgroundColor: '#fffbe6',
    borderColor: '#fff1b8',
    icon: <WarningOutlined style={{ color: colors.warning, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #faad14 0%, #ffc53d 100%)'
  },
  'Warning': {
    color: colors.warning,
    backgroundColor: '#fffbe6',
    borderColor: '#fff1b8',
    icon: <WarningOutlined style={{ color: colors.warning, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #faad14 0%, #ffc53d 100%)'
  },
  'info': {
    color: colors.info,
    backgroundColor: '#f0f5ff',
    borderColor: '#adc6ff',
    icon: <InfoCircleOutlined style={{ color: colors.info, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #1677ff 0%, #4096ff 100%)'
  },
  'Info': {
    color: colors.info,
    backgroundColor: '#f0f5ff',
    borderColor: '#adc6ff',
    icon: <InfoCircleOutlined style={{ color: colors.info, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #1677ff 0%, #4096ff 100%)'
  },
  'primary': {
    color: colors.primary,
    backgroundColor: '#e6fffb',
    borderColor: '#87e8de',
    icon: <ExclamationCircleOutlined style={{ color: colors.primary, fontSize: '20px' }} />,
    gradient: 'linear-gradient(135deg, #00796b 0%, #004d40 100%)'
  }
};

// Get status configuration with fallback
const getStatusConfig = (status) => {
  return statusConfig[status] || statusConfig['info'];
};

// Enhanced notification function
export const openNotification = (msg, title, status = 'info', options = {}) => {
  const config = getStatusConfig(status);
  
  const {
    duration = 4.5,
    placement = 'topRight',
    showProgress = true,
    closable = true,
    ...otherOptions
  } = options;

  notification.open({
    message: (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontWeight: '600',
        fontSize: '16px',
        color: colors.neutral[800],
        marginBottom: '4px'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          background: config.backgroundColor,
          border: `2px solid ${config.borderColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {config.icon}
        </div>
        <span>{title}</span>
      </div>
    ),
    description: (
      <div style={{
        marginLeft: '44px',
        fontSize: '14px',
        color: colors.neutral[600],
        lineHeight: '1.5',
        marginTop: '4px'
      }}>
        {msg}
      </div>
    ),
    icon: null, // We're using custom icon in the message
    style: {
      borderRadius: '12px',
      border: `1px solid ${config.borderColor}`,
      background: `linear-gradient(135deg, ${config.backgroundColor} 0%, #ffffff 100%)`,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      padding: '20px',
      ...otherOptions.style
    },
    className: 'custom-notification',
    duration,
    placement,
    showProgress,
    closable,
    ...otherOptions
  });
};

export const preventMinus = (e) => {
    if (e.code === 'Minus') {
        e.preventDefault();
    }
};

export const toCamelCase = (str) => {
    return str.replaceAll(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, '');
}

export const checkUppercaseAndNumb = (str) => {
    if (/[^a-zA-Z]/.test(str) && str !== str.toLowerCase()) {
        return true;
    } else {
        return false;
    }
};





export const role = JSON.parse(localStorage.getItem('user'))?.role




export const downloadProviderSnapshot = async ({ setSnapshotLoading }) => {
    setSnapshotLoading(true)
    await fetch(`${baseURL}pas/onboard/report/provider/snapshot/excel`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/octect-stream' }
    })
        .then(res => {
            const filename = res.headers.get('Content-Disposition').split('filename=')[1];
            res.blob().then((blob) => saveAs(blob, filename));
        })
        .finally(() => setSnapshotLoading(false))
}

export const Required = <span style={{ fontSize: '12px', fontWeight: '300', fontStyle: 'italic' }}>Required</span>

export const statusColor = (status) => {
    switch (status) {
        case ('Active'):
            return ('#5cb85c');
        case ('Inactive'):
            return ('#f0ad4e');
        case ('Suspended'):
            return ('#d9534f');
        case ('Deleted'):
            return ('#d9534f');
        case ('Pending'):
            return ('#5bc0de');
        case ('Approved'):
            return ('#5cb85c');
        case ('Declined'):
            return ('#d9534f');
        case ('In_Progress'):
            return ('#0275d8');
        case ('Information_Required'):
            return ('#f0ad4e');
        case ('Information_Submitted'):
            return ('#4e9af0');
    }
}
